import React from "react";
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  Button,
  IconButton,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { MODAL_CANCEL_BUTTON_STYLE, MODAL_CONFIRM_BUTTON_STYLE } from "../../styles/CommonStyles";

/**
 * Process Payout Confirmation Modal
 * Props:
 *   open, onClose, onConfirm
 *   isProcessing  — shows spinner on confirm button while API call in progress
 *   selectedCount — number of individually selected drivers
 *   selectAll     — boolean, true when all available drivers are selected
 *   fromDate      — formatted start date string
 *   toDate        — formatted end date string
 */
const ProcessPayoutConfirmation = ({
  open,
  onClose,
  onConfirm,
  isProcessing = false,
  selectedCount = 0,
  selectAll = false,
}) => {
  const driversLabel = selectAll
    ? "All available drivers"
    : `${selectedCount} selected driver${selectedCount !== 1 ? "s" : ""}`;

  return (
    <Dialog
      open={open}
      onClose={!isProcessing ? onClose : undefined}
      PaperProps={{
        sx: {
          borderRadius: "12px",
          padding: "0.7vw 1.2vw",
          minWidth: "500px",
          maxWidth: "700px",
        },
      }}
    >
      {/* Close Button */}
      <IconButton
        onClick={onClose}
        disabled={isProcessing}
        sx={{ position: "absolute", right: 16, top: 16, color: "#626262" }}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent sx={{ textAlign: "center", pt: 4, pb: 3 }}>
        <Typography sx={{ fontSize: "18px", color: "#313131", mb: 2, lineHeight: 1.6 }}>
          You're about to process payout deduction for
        </Typography>

        {/* Highlight: how many drivers */}
        <Typography sx={{ fontSize: "20px", fontWeight: 700, color: "#39B54A", mb: 1 }}>
          {driversLabel}
        </Typography>

        <Typography sx={{ fontSize: "15px", color: "#313131", mb: 4 }}>
          Please confirm before proceeding.
        </Typography>

        {/* Action Buttons */}
        <Box sx={{ display: "flex", justifyContent: "space-around", gap: 3, mt: 2 }}>
          <Button
            variant="outlined"
            onClick={onClose}
            disabled={isProcessing}
            sx={MODAL_CANCEL_BUTTON_STYLE}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            onClick={onConfirm}
            disabled={isProcessing}
            sx={MODAL_CONFIRM_BUTTON_STYLE}
            startIcon={isProcessing ? <CircularProgress size={16} color="inherit" /> : null}
          >
            {isProcessing ? "Processing..." : "Confirm"}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ProcessPayoutConfirmation;
